import { topicTags } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">话题广场</h2>
          <p className="text-sm text-foreground-500">热门话题标签，快速定位你感兴趣的瓜</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicTags.map((tag) => (
            <a
              key={tag.id}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tag.hot && <i className="ri-fire-line text-primary-500 text-xs"></i>}
              <span>{tag.name}</span>
              <span className={`text-xs ${tag.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}